import { FRONTIER_TRAILS } from './frontier.js';

export const HEARTH_RECOVERY = Object.freeze({ delay: 8, hpPerSecond: 4, threatRadius: 12 });

export const TRAIL_SEGMENTS = Object.freeze([
  ...FRONTIER_TRAILS,
  [0, 31, 0, 7], [0, 7, 17, -8], [17, -8, 19, -20],
  [1, 6, 18, 15], [0, 7, -17, -11], [18, 15, 19, 17],
  [0, 7, -28, 18], [0, 7, -16, -3],
]);

export function trailWeight(x, z) {
  let nearest = Infinity;
  for (const [ax, az, bx, bz] of TRAIL_SEGMENTS) {
    const dx = bx - ax;
    const dz = bz - az;
    const t = Math.max(0, Math.min(1, ((x - ax) * dx + (z - az) * dz) / (dx * dx + dz * dz)));
    nearest = Math.min(nearest, Math.hypot(x - ax - t * dx, z - az - t * dz));
  }
  return Math.max(0, Math.min(1, (2.2 - nearest) / 1.4));
}

export function recoverAtHearth(hp, maxHp, dt, { inside, threatened, cooldown, sprinting, attacking }) {
  if (!inside || threatened || cooldown > 0 || sprinting || attacking || hp <= 0) return hp;
  return Math.min(maxHp, hp + HEARTH_RECOVERY.hpPerSecond * Math.max(0, dt));
}

export function snappedShadowFocus(value, span = 44, resolution = 1024) {
  const texel = span / resolution;
  return Math.round(value / texel) * texel;
}
